import BannerSliderDesk from "./Desk/BannerSliderDesk";
import BannerSliderMob from "./Mob/BannerSliderMob";

const BannerSlider = () => {
  return <>{window.innerWidth <= 768 ? <BannerSliderMob /> : <BannerSliderDesk />}</>;
};

export default BannerSlider;
